<template>
  <div class="graphics container">
    <canvas class="canvas" id="dotacion-edad"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  data() {
    return {
      img: "",
      myChart: null,
      graphicLabels: null,
      graphicData: null,
    };
  },
  props: ["labels", "data", "highestValue"],
  watch: {
    labels: function() {
      this.graphicLabels = this.$props.labels[0];
    },
    data: function() {
      this.graphicData = this.$props.data[0];
      this.grafica();
    },
  },
  methods: {
    grafica: function() {
      var ctx = document.getElementById("dotacion-edad").getContext("2d");
      if (this.myChart) {
        this.myChart.destroy();
      }

      const footer = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach((tooltipItem) => {
          sum = `${this.graphicData.perc[tooltipItem.parsed.x]}%`;
        });
        return sum;
      };
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.graphicLabels,
          datasets: [
            {
              label: "Dotación edad",
              data: this.graphicData.values,
              backgroundColor: [
                "#770BAA",
                "#2ECC71",
                "#096496",
                "#FF1AFF",
                "#2C3E50",
                "#D35400",
                "#BDC3C7",
              ],
              borderColor: [
                "#770BAA",
                "#2ECC71",
                "#096496",
                "#FF1AFF",
                "#2C3E50",
                "#D35400",
                "#BDC3C7",
              ],
              barThickness: 40,
            },
          ],
        },
        options: {
          scales: {
            x: {
              title: {
                display: true,
                text: "Edad",
                font: {
                  weight: "bold",
                },
              },
              grid: {
                display: false,
              },
            },
            y: {
              max: this.highestValue,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold",
                },
              }
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: {
              callbacks: {
                footer: footer,
              },
            },
          },
        },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
}
.graphics {
  padding-bottom: 2rem;
  padding: 1rem 5rem;
}
</style>
